import type {
  AddToWishlistRequest,
  AddToWishlistResponse,
  GetWishlistRequest,
  GetWishlistResponse,
  RemoveFromWishlistRequest,
  RemoveFromWishlistResponse,
} from '@/infrastructure/wishlist/utils/types';
import { client } from '../common/client';

class WishlistAPIClient {
  public async getWishlist(request: GetWishlistRequest): Promise<GetWishlistResponse> {
    return await client
      .get(`/wishlist`, {
        params: request,
      })
      .then((res) => res.json());
  }

  public async addProductToWishlist(payload: AddToWishlistRequest): Promise<AddToWishlistResponse> {
    return await client.post(`/wishlist/addProduct`, { body: payload }).then((res) => res.json());
  }

  public async removeProductFromWishlist(payload: RemoveFromWishlistRequest): Promise<RemoveFromWishlistResponse> {
    return await client.delete(`/wishlist/removeProduct`, { body: payload }).then(async (res) => {
      const text = await res.text();
      try {
        return JSON.parse(text);
      } catch {
        return undefined;
      }
    });
  }
}

export const wishlistAPIClient = new WishlistAPIClient();
